module.exports = __webpack_public_path__ + "img/life-page4-img-4.afb59239.jpg";